import { SvgIcon, SvgIconProps } from '@mui/material';

export default function AgencyProfileIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 26 24">
      <g fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.25 18C18.0784 18 18.75 17.3284 18.75 16.5C18.75 15.6716 18.0784 15 17.25 15C16.4216 15 15.75 15.6716 15.75 16.5C15.75 17.3284 16.4216 18 17.25 18Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.524 10.6998L18.966 12.1528C19.1169 12.6531 19.6297 12.9508 20.139 12.8338L21.612 12.4918C22.1849 12.3628 22.7751 12.6221 23.0675 13.1314C23.3599 13.6407 23.2863 14.2811 22.886 14.7108L21.856 15.8218C21.4991 16.2057 21.4991 16.8 21.856 17.1838L22.886 18.2948C23.287 18.7242 23.3609 19.365 23.0683 19.8744C22.7757 20.3839 22.185 20.6428 21.612 20.5128L20.139 20.1718C19.6297 20.0543 19.1165 20.3522 18.966 20.8528L18.524 22.2998C18.3547 22.8622 17.8368 23.2471 17.2495 23.2471C16.6622 23.2471 16.1443 22.8622 15.975 22.2998L15.533 20.8478C15.3825 20.3472 14.8694 20.0493 14.36 20.1668L12.887 20.5078C12.3141 20.6378 11.7233 20.3789 11.4307 19.8694C11.1381 19.36 11.212 18.7192 11.613 18.2898L12.643 17.1788C13 16.795 13 16.2007 12.643 15.8168L11.613 14.7058C11.2127 14.2761 11.1391 13.6357 11.4315 13.1264C11.7239 12.6171 12.3141 12.3578 12.887 12.4868L14.36 12.8288C14.8693 12.9458 15.3821 12.6481 15.533 12.1478L15.975 10.6948C16.1454 10.1328 16.6641 9.74885 17.2514 9.75C17.8387 9.75115 18.3558 10.1371 18.524 10.6998Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.256 10.1002C9.22914 9.37992 8.00428 8.99563 6.75 9.00019C3.70837 8.97634 1.13012 11.2323 0.75 14.2502"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.75 7.5C8.61396 7.5 10.125 5.98896 10.125 4.125C10.125 2.26104 8.61396 0.75 6.75 0.75C4.88604 0.75 3.375 2.26104 3.375 4.125C3.375 5.98896 4.88604 7.5 6.75 7.5Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.5 6C17.9497 6 19.125 4.82475 19.125 3.375C19.125 1.92525 17.9497 0.75 16.5 0.75C15.0503 0.75 13.875 1.92525 13.875 3.375C13.875 4.82475 15.0503 6 16.5 6Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.5263 7.9213C18.6319 7.10871 17.4483 6.68998 16.2418 6.75939C15.0354 6.82879 13.9076 7.3805 13.1123 8.2903"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </SvgIcon>
  );
}
